import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getAuth } from 'firebase/auth';
import { PrizeCategory } from './model/category';
import { Gift } from './model/gift';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private baseUrl = environment.apiUrl + '/api/admin';

  constructor(private http: HttpClient) {}

  getAllCategories(): Observable<PrizeCategory[]> {
    return this.withAuthHeader<PrizeCategory[]>((headers) =>
      this.http.get<PrizeCategory[]>(`${this.baseUrl}/prizes-categories`, { headers })
    );
  }

  createCategory(categoryName: string): Observable<any> {
    return this.withAuthHeader((headers) =>
      this.http.post(`${this.baseUrl}/prizes-category`, { categoryName }, { headers })
    );
  }

  addGift(categoryName: string, gift: Gift): Observable<any> {
    return this.withAuthHeader((headers) =>
      this.http.post(`${this.baseUrl}/prizes-category/${categoryName}/add-gift`, gift, { headers })
    );
  }

  deleteGift(categoryName: string, gift: Gift): Observable<any> {
    return this.withAuthHeader((headers) =>
      this.http.request('delete', `${this.baseUrl}/prizes-category/${categoryName}/delete-gift`, {
        headers,
        body: gift,
      })
    );
  }

  private withAuthHeader<T>(requestFn: (headers: HttpHeaders) => Observable<T>): Observable<T> {
    const auth = getAuth();
    return from(auth.currentUser?.getIdToken(true) ?? Promise.reject('Nincs bejelentkezett felhasználó')).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return requestFn(headers);
      })
    );
  }
}
